import { StorageAdapter } from './storageInterface';
import { MedianStorageAdapter } from './medianStorageAdapter';
import { WebStorageAdapter } from './webStorageAdapter';
import { hasNativeDatastore } from './medianDetector';

/**
 * Service de stockage unifié
 * Détecte automatiquement Median ou fallback sur localStorage
 */
class StorageService {
  private adapter: StorageAdapter;
  private isMedian: boolean;

  constructor() {
    this.isMedian = hasNativeDatastore();
    
    if (this.isMedian) {
      console.log('[StorageService] Using Median Native Datastore');
      this.adapter = new MedianStorageAdapter();
    } else {
      console.log('[StorageService] Using Web localStorage');
      this.adapter = new WebStorageAdapter();
    }
  }

  get isNativeStorage(): boolean {
    return this.isMedian;
  }

  get<T>(key: string): Promise<T | null> {
    return this.adapter.get<T>(key);
  }

  set<T>(key: string, value: T): Promise<void> {
    return this.adapter.set(key, value);
  }

  remove(key: string): Promise<void> {
    return this.adapter.remove(key);
  }

  clear(): Promise<void> {
    return this.adapter.clear();
  }

  keys(): Promise<string[]> {
    return this.adapter.keys();
  }
}

export const storageService = new StorageService();
